export default{
	data(){
		return{
			// 加载
			loading:false,
			//在读课程
			inschoolclass: [],
			// 已完成证书
			accomplishcredential: [],
			//已完成的证书
			okCertificate: [],
			// 每页显示条数
			pageSize: 5,
			// 当前页
			currentPage: 1,
			// 总页数
			total: 0,
			//选择打印证书按钮
			certificateButton: true,
            // 套餐名称
            categoryName: '',
		}
	},
	methods:{
		// 筛选
		// cosl2(type){
		// 	let data = {
		// 		token: this.$store.state.id,
		// 		offset: (this.currentPage - 1) * this.pageSize,
		// 	    length: this.pageSize
		// 	}
		// 	let url = ''
		// 	if(type == 1){
		// 		url = 'orders/search_pay_all'
		// 		data.is_read = '是'
		// 		this.getData(url, data,type)
		// 	}else if(type == 2){
		// 		url = 'orders/search_pay_all'
		// 		data.category_progress_egt = 1
		// 		data.score_egt = 60
		// 		this.getData(url, data,type)
		// 	}else if(type == 3){
		// 		this.isShowPagination = false
		// 		this.alreadyCreated();
		// 	}
			
		// },
		
		//获取数据
		// getData(url,data,type){
		// 	this.$post(url,data).then(res=>{
		// 		if(type == 1){
		// 			this.inschoolclass = res.data.result.result;
		// 			this.total = res.data.result.total
		// 		}else if (type == 2){
		// 			this.accomplishcredential = res.data.result.result;
		// 			this.total = res.data.result.total
		// 		}
		// 	})
		// },
		
		//获取已经生成的证书
		alreadyCreated: function() {
			this.okCertificate = [];
			this.$post('cers/search', {
				token: this.$store.state.id,
				offset: 0,
				length: 999
			}).then(res => {
				console.log(res)
		        this.okCertificate = res.data.result.data;
			})
			
		},
		
		// 每页的显示条数改变时调用
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.getData()
		},
		
		// 当前页改变时调用
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.getData()
		},
		//跳转课程详情
		classDetails: function(id, is_project, purchased_id, categoryOrderId) {
		    let address = this.$router.resolve({
		        path: '/classstudy',
		        query: {
		            id: id,
		            purchased_id: purchased_id,
		            categoryOrderId: categoryOrderId
		        }
		    });
		    window.open(address.href, "_blank")
			// this.$toClass(id, is_project, purchased_id);
		},
		// 打印证书
		printCertificate(item) {
		    let categoryId = item.category_id;
		    this.categoryName = item.name;
		    let categoryYear = item.year;
		    let categoryOrderId = item.category_order_id;
		    
		    // 获取当前课程包的开始学习时间和结束学习时间
		    this.$post('category_order/get_date', {
		        id: categoryOrderId
		    }).then(res => {
		        let {
		            study_start_time,
		            study_end_time
		        } = res.data.result;
		    
		        if (this.$store.state.store.id == 107) {
		           // 创建证书
		           this.$post('cers/create', {
		               token: this.$store.state.id,
		               category_ids: JSON.stringify([categoryId]),
		               cer_year: categoryYear,
		               pay_date: study_start_time,
		               end_date: study_end_time
		           }).then(res2 => {
		                       
		               // 生成证书后，将当前的课程包的是否已生成证书修改为已生成
		               this.$post('category_order/update', {
		                   id: categoryOrderId,
		                   is_first: 1
		               });
		                       
		               // 跳转到证书页面
		               this.goCertificate(study_start_time, study_end_time, JSON.stringify([
		                   categoryId]), Number.parseFloat(
		                   categoryYear));
		           })
		        } else {
		            this.$post('cers/makeCert', {
		                category_id:categoryId,
		                category_name:this.categoryName,
		                cer_year:categoryYear,
		                pay_date:study_start_time,
		                end_date:study_end_time,
		                token: this.$store.state.id,
		            }).then(res=>{
		                window.open(`${window.location.origin}/${res.data.result.file_path}`)
		            })
		        }
		    })
		},
		//证书详情页面跳转
		goCertificate: function(pay_date, end_date, categoryIds, year) {
			// UIkit.modal(document.querySelector('#modal-personalcenter')).hide()
			// // 修改为当前页跳转
			// this.$router.push({
			//     path: '/studyingcertificate',
			//     query: {
			//         pay_date: pay_date,
			//         end_date: end_date,
			//         goodId: goodId,
			//         year: year
			//     }
			// })
			let address = this.$router.resolve({
				path: '/studyingcertificate',
				query: {
					pay_date: pay_date,
					end_date: end_date,
					categoryIds: categoryIds,
					year: year,
					name: this.categoryName
				}
			});
			window.open(address.href, '_blank');
		},
		//下载证书
		downloadBook: function(item) {
		    let cersId = item.cer_id
		    // 获取证书的信息
		    this.$post('cers/get', {
		        id: cersId
		    }).then(res => {
		        let {
		            category_ids,
		            cer_year,
		            pay_date,
		            end_date
		        } = res.data.result;
		        
		        if(this.$store.state.store.id == 107){
		            // 获取当前证书名称
		            this.$post('product_category/get_categorys', {
		                category_ids: category_ids,
		                offset: 0,
		                length: 999
		            }).then(res2 => {
		                let list = res2.data.result.data;
		            
		                // 目前是一个课程包一个证书，到时候变再改
		                // for (let item of list) {
		                //     this.categoryName.push(item.name);
		                // }
		                this.categoryName = list[0].name
		            
		                // 跳转到证书页面
		                this.goCertificate(pay_date, end_date, category_ids, cer_year);
		            });
		        }else{
		            this.printCertificate(item)
		        }
		        
		    })
		
		    // let ids = []
		    // item.purchased.map(item => {
		    // 	ids.push(item.purchased_id)
		    // })
		    // this.categoryName = item.category_name
		    // //判断如果是id是5，即高校店铺则要跳转不同页面打印不同的学时证明
		    // if (this.$store.state.store.id == "5") {
		    // 	this.highSchoolCertificate(item.pay_date, item.end_date, item.cer_year);
		    // } else {
		    // 	//不是高校店铺的学时证明
		    // 	this.goCertificate(item.pay_date, item.end_date, JSON.stringify(ids), item.cer_year)
		    // }
		
		},
	},
	created(){
		this.alreadyCreated()
	}
}